module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Light.2e62a4b.ttf";